import { FormControl, Paper, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useTheme } from "@mui/styles";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../reducers/userSlice";
import { selectRTFO } from "../../reducers/rtfoSlice";
import { FBASummarySection } from "../fba/FBASummarySection";
import { FBASummaryChart } from "../fba/FBASummaryChart";
import axios from "axios";

export const RTFOFBA = ({ currentWellName }) => {

  const theme = useTheme();
  const user = useSelector(selectUser);
  const darkMode = user?.value?.darkMode;
  // const fba = useSelector(selectFBA);
  const rtfo = useSelector(selectRTFO);
  const currentRTFO = rtfo?.value;

  const fbaLink = currentWellName?.toLowerCase() === 'all' ? currentRTFO?.fbas?.wells?.[Object.keys(currentRTFO?.fbas?.wells || {})?.[0]] : currentRTFO?.fbas?.wells?.[currentWellName?.toLowerCase()];
  // const startIndex = fbaLink?.lastIndexOf("/") + 1;
  // const endIndex = fbaLink?.lastIndexOf(".json");
  // const fbaId = fbaLink?.substring(startIndex, endIndex);
  // let currentFBA = fba?.byId?.[fbaId];

  const [fba, setFBA] = useState(null);
  const [fbaUnits, setFBAUnits] = useState(fba?.settings?.units?.value || 'field');


  useEffect(() => {
    if (fbaLink) {
      console.log('Loading FBA...');

      fetchFBA(fbaLink).then(res => {
        setFBA(res);
      });
            
      // dispatch(loadFBA({ fbaId, location: fbaLink, keepId: false }));
    };
    
    async function fetchFBA(link) {
      const _fba = await axios.get(link)
      return _fba?.data;
    };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fbaLink, currentWellName, currentRTFO?.currentStageName]);

  return (
    <Paper style={{display: 'flex', margin: '0 20px', position: 'relative', flexDirection: 'column', padding: 4, backgroundColor: (theme?.palette?.elevationOne?.[(darkMode ? 'dark' : 'light')])}} elevation={0} sx={{boxShadow: 1}}>

      {fba ? 
        <div style={{margin: 20, position: 'relative'}}>
          <Typography variant="h6">FBA Summary</Typography>
          <Typography style={{fontSize: '16px'}}>{currentWellName} Well</Typography>

          <FormControl component="fieldset" style={{width: 200, padding: '0 10px', position: 'absolute', top: 0, right: 0}}>
            <Typography>Units</Typography>
            <ToggleButtonGroup
              value={fbaUnits}
              exclusive
              onChange={(e, newVal) => newVal && setFBAUnits(newVal)}
              size="small"
              style={{height: 30, width: '100%', display: 'flex', justifyContent: 'center', marginBottom: 10}}
            >
              <ToggleButton value="metric" size="small" style={{width: '50%'}} color={(darkMode ? "" : "primary")}>
                <Typography style={{fontSize: 12}}>
                  Metric
                </Typography>
              </ToggleButton>
              <ToggleButton value="field" size="small" style={{width: '50%'}} color={(darkMode ? "" : "primary")}>
                <Typography style={{fontSize: 12}}>
                  Field
                </Typography>
              </ToggleButton>
            </ToggleButtonGroup>
          </FormControl>


          <FBASummarySection fba={fba} units={fbaUnits} />
          <FBASummaryChart fba={fba} units={fbaUnits} />
          {/* <FBASummaryDataTable fba={currentFBA} blur={true} units={fbaUnits} /> */}

        </div> :
        <div style={{height: 540, width: '100%', margin: 20, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <Typography style={{marginBottom: 10}}>No FBA loaded</Typography>
        </div>
      }


    </Paper>
  )

};